<script setup lang="ts">
import IconDown from 'assets/icons/arrow-down.svg';
import IconUp from 'assets/icons/arrow-up.svg';

export type TLink = {
  href?: string;
  label: string;
  cb?: () => void;
};

type TSide = 'left' | 'right';

const { t } = useI18n();

withDefaults(
  defineProps<{ title?: string; links: TLink[]; side?: TSide; href?: string }>(),
  {
    side: 'left',
    title: '',
    href: '',
  });

const onClick = async (link: TLink) => {
  if (link.cb) {
    link.cb();
  }
  else {
    await navigateTo(link.href || '/');
  }
};
</script>

<template>
  <HeadlessMenu
    v-slot="{ open }"
    as="div"
    class="relative cursor-pointer flex"
  >
    <HeadlessMenuButton>
      <slot name="default">
        <slot name="prepend" />
        <ButtonLevel
          type="4"
          :title="t(title).toUpperCase()"
          :href="href"
        >
          <template #append>
            <IconDown v-if="!open" />
            <IconUp v-else />
          </template>
        </ButtonLevel>
      </slot>
    </HeadlessMenuButton>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <HeadlessMenuItems
        :class="{
          'left-0': side === 'left',
          'right-0': side === 'right',
        }"
        class="z-10 absolute top-10 mt-3 rounded-medium bg-white shadow-highlight"
      >
        <HeadlessMenuItem
          v-for="(link, i) in links"
          :key="link.label"
          v-slot="{ active }"
          as="div"
        >
          <a
            v-if="link.href"
            :href="link.href"
          >
            <div
              :class="[
                i === 0 ? 'rounded-t-medium' : '',
                i === links.length-1 ? 'rounded-b-medium' : '',
                active ? 'bg-gray-300 font-thicker !text-gray-900' : '',
                'w-full !justify-start text-big py-2 px-4 whitespace-nowrap',
              ]"

              @click="onClick(link)"
            >
              {{ t(link.label) }}
            </div>
          </a>
          <div
            v-else
            :class="[
              i === 0 ? 'rounded-t-medium' : '',
              i === links.length-1 ? 'rounded-b-medium' : '',
              active ? 'bg-gray-300 font-thicker !text-gray-900' : '',
              'w-full !justify-start text-big py-2 px-4 whitespace-nowrap',
            ]"

            @click="onClick(link)"
          >
            {{ t(link.label) }}
          </div>
        </HeadlessMenuItem>
      </HeadlessMenuItems>
    </transition>
  </HeadlessMenu>
</template>

<style scoped>

</style>
